import { render } from "./SelectedAssignment.vue?vue&type=template&id=0954b425&scoped=true"
import script from "./SelectedAssignment.vue?vue&type=script&lang=js"
export * from "./SelectedAssignment.vue?vue&type=script&lang=js"

import "./SelectedAssignment.vue?vue&type=style&index=0&id=0954b425&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0954b425"]])

export default __exports__